import { get } from "lodash";

export const selectCheckoutId = (state: any) => get(state.cart, "id");
export const selectCartId = (state: any) => get(state.cart, "id");
export const selectMe = (state: any) => get(state.auth, "user");
export const selectCartItems = (state: any) => get(state.cart, "lineItems");
export const selectLoggedIn = (state: any) => get(state.auth, "loggedIn");
